import { stripMarkup } from '@/utils/string';

export default {
  metaInfo() {
    return {
      title: stripMarkup(this.$tf(`common.navigation_${this.$route.name}`)),
    };
  },
};
